import { Action } from '@ngrx/store'
import { HubConnection } from '@microsoft/signalr'

export const CHANGE_STATUS = '[Signal] Change Status'

export class ChangeStatus implements Action {
  readonly type = CHANGE_STATUS

  constructor(public payload: { status: string, connection?: HubConnection }) {
  }
}

export type SignalRActions = ChangeStatus




// WEBPACK FOOTER //
// ./src/app/shared/signalR/store/actions/signalR.actions.ts